/* eslint-disable */

// Mencegah error resize observer loop
const resizeObserverLoopErr = 'ResizeObserver loop limit exceeded';

// Mencegah error ekstensi Chrome (Disconnected port)
const extensionErr = 'Attempting to use a disconnected port object';

// Event Listener dengan Capture Phase (true) agar jalan DULUAN sebelum React
window.addEventListener('error', (event) => {
  if (event.message && (
      event.message.includes(resizeObserverLoopErr) || 
      event.message.includes(extensionErr)
    )) {
    event.stopImmediatePropagation(); // MATIKAN Error agar tidak lanjut ke React
    event.preventDefault(); // Jangan tampilkan di console merah
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && (
      event.reason.message.includes(resizeObserverLoopErr) || 
      event.reason.message.includes(extensionErr)
    )) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);